import React from 'react'
import styled from 'styled-components'
import colors from '../../colors'


const FooterContainer = styled.div`
    border-top: 3px solid orange;
    background: ${colors.darkgrey};
    color: ${colors.lightgrey};
    padding: 10px;
    text-align:center;
`

const Footer = () => {
    return <FooterContainer>
        <p>&copy; Ryklin Oy </p>
    </FooterContainer>
}

export default Footer